import { render, staticRenderFns } from "./DeleteQuestionModal.vue?vue&type=template&id=2e25f347&"
import script from "./DeleteQuestionModal.vue?vue&type=script&lang=js&"
export * from "./DeleteQuestionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports